import { Goal } from '@griply/types';

import { canGoalHaveChildren } from './can-goal-have-children';

// Firestore lets a project keep children a legacy client gave it.
export const hasGroupableSubGoals = (
  goal: Pick<Goal, 'type'> | undefined | null,
  subGoals: Goal[],
): boolean => canGoalHaveChildren(goal) && !!subGoals.length;
